import { Button, Input, InputType, View, ViewHeader } from '../../../../core/components/Index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import { AppPermissions } from '../../../../core/services/AppPermissions';

const SpcView = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  vm.navigate = useNavigate();

  return (
    <>
      <View
        id="SpcView"
        pageTitle='Service Purchase Calculator'
        showMenuBar={false} authKey={AppPermissions.PublicAccess}      >
        <ViewHeader title='Service Purchase Calculator' backUrl="" />
        <p>Please note down the Identifier if you need to continue to work on the estimation..</p>
        <div className="space-y-[36px] mt-[24px]" id="formContainer">
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <Input
                id="guId"
                value={vm.model.guId}
                onChange={(e) => vm.onInputChange(e, 'guId', vm.model)}
                label="Member Identifier"
                required={true}
                maxLength={40}
              />
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <Button onClick={async () => await vm.getFormattedUrlAsync()} title='Generate Your Preliminary Estimate' />
          </div>
        </div>
      </View >
    </>
  );
});

export default SpcView;
